module.exports = __webpack_public_path__ + "img/questionnaire-image-en.4e0275c9.jpg";